var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:_vm.$style.badge,attrs:{"color":_vm.badgeColor,"small":""}},[_vm._v(" "+_vm._s(_vm.$t(("transaction.status." + _vm.transactionStatus)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }